import App from './App.svelte';
import Profile from  './Profile.svelte'
import Footer from './Footer.svelte'
import Navigation from './Components/Navigation.svelte'


const app = new App({
	target: document.getElementById('main')
});
new Profile({
	target:document.getElementById('subnav')
});
new Footer({
	target:document.getElementById('footer')
});
new Navigation({
	target:document.getElementById('navigation')
})

export default app;  